// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import { Row, Card, CardBody, Table } from 'reactstrap'
import Analyse from '../../../../Model/Analyse';
import DataTableRow from '../../../../Components/DataTableRow';
import StringDataTableEntry from '../../../../Components/StringDataTableEntry'

type Props = {
  analyse: Analyse,
};

@observer
export default class ReferenzWertRows extends React.Component<Props, void> {
  render() {
    const { analyse: { referenzwert } } = this.props;

    return (
      <React.Fragment>
        <DataTableRow title={'Erwachsene'}>
          <StringDataTableEntry entity={referenzwert} field={'erwachsen'} />
        </DataTableRow>
        <DataTableRow title={'Männlich'}>
          <StringDataTableEntry entity={referenzwert} field={'maennlich'} />
        </DataTableRow>
        <DataTableRow title={'Weiblich'}>
          <StringDataTableEntry entity={referenzwert} field={'weiblich'} />
        </DataTableRow>
        <DataTableRow title={'Kind'}>
          <StringDataTableEntry entity={referenzwert} field={'kind'} />
        </DataTableRow>
        <DataTableRow title={'Neugeborenes'}>
          <StringDataTableEntry entity={referenzwert} field={'neugeborenes'} />
        </DataTableRow>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Views/Analysis/View/AnalyseForm/ReferenzWertRows.js